// extracted by mini-css-extract-plugin
export var car = "styles-module--car--Cm5-1";
export var component = "styles-module--component--uldTH";
export var image = "styles-module--image--JzWhK";